import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => {
    return {
        paper: {
            width: '100%',
            minWidth: 'unset',
            maxWidth: 400,
        },
        title: {
            paddingBottom: 0,
            marginTop: '20px',
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            paddingBottom: '55px',
        },
    };
});
